import CharacterCustomization from "./components/CharacterCustomization";

export default CharacterCustomization;
